import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import { StyledSelect } from "../../../../components/forms/styles/formFieldStyles";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { workflowsIcons } from "../../../stack/environment/icons/iconExport";
import { getIconByCategory } from "../utils";
const OptionSelector = ({
  options = [],
  onSelect,
  onCancel,
  placeholder = "Select option...",
  ParentSelectedOption = null,
}) => {
  const colors = useColors();
  const [selectedValue, setSelectedValue] = useState("");

  const groupedOptions = options.reduce((acc, option) => {
    const category = option.category || "Other";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(option);
    return acc;
  }, {});

  const handleChange = (event) => {
    const optionId = event.target.value;
    const selectedOption = options.find((option) => option.id === optionId);

    if (selectedOption) {
      onSelect(selectedOption);
      setSelectedValue(""); // Reset selection
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onCancel();
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: colors.common_white,
        borderRadius: "8px",
        border: "none",
        width: "100%",
      }}
    >
      <FormControl fullWidth size="small">
        <InputLabel
          id="option-selector-label"
          sx={{ color: colors.text_secondary }}
        >
          {placeholder}
        </InputLabel>
        <StyledSelect
          variant="outlined"
          labelId="option-selector-label"
          label={placeholder}
          value={selectedValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          IconComponent={ExpandMoreIcon}
          autoFocus
          sx={{
            backgroundColor: colors.common_white,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.grey_20percent,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.grey_20percent,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.grey_20percent,
            },
          }}
        >
          {Object.entries(groupedOptions)
            .map(([category, categoryOptions]) => [
              // Category Options
              ...categoryOptions.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                  sx={{
                    paddingLeft: "24px", // Indent under category
                    "&:hover": {
                      backgroundColor: colors.primary_5percent,
                    },
                  }}
                >
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={1}
                    flex={1}
                  >
                    <SvgToIcon
                      IconLogo={
                        ParentSelectedOption
                          ? getIconByCategory(
                              ParentSelectedOption.type,
                              option.type
                            )
                          : workflowsIcons[option.type]
                      }
                      width="16px"
                      height="16px"
                    />
                    <ListItemText
                      primary={
                        <Typography
                          variant="caption"
                          sx={{ color: colors.text_secondary }}
                        >
                          {option.description}
                        </Typography>
                      }
                    />
                  </Box>
                </MenuItem>
              )),
            ])
            .flat()}
        </StyledSelect>
      </FormControl>
    </Box>
  );
};

export default OptionSelector;
